/* VERON · Kürzlich angesehen — localStorage, max 8 Handles.
   Key: veron:recent:v1 */
(function () {
  'use strict';
  var KEY = 'veron:recent:v1', MAX = 8;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function push(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function init() {
    var strip = document.getElementById('veron-recent-strip');
    var current = document.body.getAttribute('data-veron-product-handle') ||
      (strip ? strip.getAttribute('data-current') : null);

    var toShow = read().filter(function (h) { return h !== current; }).slice(0, 4);

    if (current) push(current);
    if (!strip || !toShow.length) { if (strip) strip.closest('.veron-recent') && (strip.closest('.veron-recent').hidden = true); return; }

    toShow.forEach(function (h, idx) {
      fetch('/products/' + h + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var el = document.createElement('a');
          el.className = 'veron-recent__item';
          el.href = p.url;
          var img = p.featured_image
            ? '<img loading="lazy" src="' + p.featured_image + '&width=360" alt="">'
            : '<span class="veron-recent__mono">' + (p.vendor || 'V').slice(0, 2).toUpperCase() + '</span>';
          el.innerHTML =
            '<div class="veron-recent__media veron-recent__media--' + ['a','b','c','d'][idx % 4] + '">' + img + '</div>' +
            '<div class="veron-recent__name">' + p.title + '</div>' +
            '<div class="veron-recent__price">' + money(p.price) + '</div>';
          strip.appendChild(el);
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
